import { AlertCircle } from 'lucide-react';
import { Card, CardContent } from './ui/card';

export function ScreenError({ message, children }: { message: string; children: React.ReactNode }) {
  return (
    <div className="w-full max-w-[400px]">
      <Card className="mb-6">
        <CardContent className="flex flex-col items-center gap-4 py-8 text-center">
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-red-50">
            <AlertCircle className="h-8 w-8 text-red-500" />
          </div>
          <h1 className="text-xl font-semibold text-red-600">Erreur</h1>
          <p className="text-[15px] text-gray-500 leading-relaxed">{message}</p>
        </CardContent>
      </Card>
      {children}
    </div>
  );
}
